// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R9tJ6","label":"styles_label__1Y9bg"};